'use strict';

exports.__esModule = true;
exports.default = createActions;

var _utils = require('./utils');

var _createTypes = require('./createTypes');

var _createTypes2 = _interopRequireDefault(_createTypes);

var _createCreators = require('./createCreators');

var _createCreators2 = _interopRequireDefault(_createCreators);

var _validateConfig = require('./validateConfig');

var _validateConfig2 = _interopRequireDefault(_validateConfig);

var _toExternalTypes = require('./toExternalTypes');

var _toExternalTypes2 = _interopRequireDefault(_toExternalTypes);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}
/*
  @param {string} namespace - namespace to be uppercased and prefix your action types
  @param {Array} config - object with options
*/


function createActions(namespace, config) {
  var NAMESPACE = (0, _utils.parseToUppercase)(namespace);
  (0, _validateConfig2.default)(NAMESPACE, config);
  var actionKeys = Object.keys(config);
  var actionTypes = (0, _createTypes2.default)(actionKeys, NAMESPACE);
  var creators = (0, _createCreators2.default)(config, actionTypes);
  return {
    creators: creators,
    types: (0, _toExternalTypes2.default)(config, actionTypes)
  };
}